// src/services/attendanceApi.js
import apiWithAuth from './apiWithAuth';

const api = apiWithAuth;

// Mark attendance for an employee
export const markAttendance = (attendanceData) =>
    api.post('/admin-panel/attendance/mark', attendanceData);

// Get all attendance for a specific date
export const getAttendanceByDate = (date) =>
    api.get(`/admin-panel/attendance/date/${date}`);

// Get attendance for a specific employee
export const getEmployeeAttendance = (employeeId, startDate, endDate) =>
    api.get(`/admin-panel/attendance/employee/${employeeId}`, {
        params: { startDate, endDate }
    });

// Get attendance summary for a specific employee
export const getEmployeeAttendanceSummary = (employeeId, startDate, endDate) =>
    api.get(`/admin-panel/attendance/employee/${employeeId}/summary`, {
        params: { startDate, endDate }
    });

// Get attendance report for all employees
export const getAttendanceReport = (startDate, endDate, department = null) => {
    const params = { startDate, endDate };
    if (department) params.department = department;
    return api.get('/admin-panel/attendance/report', { params });
};

// Update attendance record
export const updateAttendance = (attendanceId, updateData) =>
    api.put(`/admin-panel/attendance/${attendanceId}`, updateData);

// Delete attendance record
export const deleteAttendance = (attendanceId) =>
    api.delete(`/admin-panel/attendance/${attendanceId}`);

const attendanceApi = {
    markAttendance,
    getAttendanceByDate,
    getEmployeeAttendance,
    getEmployeeAttendanceSummary,
    getAttendanceReport,
    updateAttendance,
    deleteAttendance
};

export default attendanceApi;
